import './mouseCursor.css.js';
const MOUSE_CURSOR_TEXT_CSS_CLASS_NAME = `monaco-mouse-cursor-text`;
export { MOUSE_CURSOR_TEXT_CSS_CLASS_NAME };
